import { Injectable, inject } from '@angular/core';
import { combineLatest, interval, type Observable, of } from 'rxjs';
import { debounce, map } from 'rxjs/operators';
import { BuildingsProvider } from '../buildings/buildings.provider';
import { BusinessIndicatorsProvider } from '../business-indicator/business-indicators.provider';
import { CategoriesProvider } from '../categories/categories.provider';
import { ContactsProvider } from '../contacts/contacts.provider';
import { DashboardsProvider } from '../dashboards/dashboards.provider';
import { DeliveryPointProvider } from '../delivery-point/delivery-point.provider';
import { MeterProvider } from '../meter/meter.provider';
import { PointUsageProvider } from '../point-usage/point-usage.provider';
import { ProfileProvider } from '../profile/profile.provider';
import { ProjectsProvider } from '../projects/projects.provider';
import { SensorsProvider } from '../sensors/sensors.provider';
import { TailoredWidgetsProvider } from '../tailored-widgets/tailored-widgets.provider';

@Injectable({
    providedIn: 'root'
})
export class AppStatusProvider {
    private _buildingsProvider = inject(BuildingsProvider);
    private _deliveryPointsProvider = inject(DeliveryPointProvider);
    private _profileProvider = inject(ProfileProvider);
    private _contactsProvider = inject(ContactsProvider);
    private _usageProvider = inject(PointUsageProvider);
    private _metersProvider = inject(MeterProvider);
    private _sensorsProvider = inject(SensorsProvider);
    private _categoriesProvider = inject(CategoriesProvider);
    private _businessIndicatorsProvider = inject(BusinessIndicatorsProvider);
    private _projectsProvider = inject(ProjectsProvider);
    private _dashboardsProvider = inject(DashboardsProvider);
    private _tailoredWidgetsProvider = inject(TailoredWidgetsProvider);

    isProjectDataLoading$(): Observable<boolean> {
        return combineLatest([
            this._projectsProvider.isChangingProject$(),
            this._buildingsProvider.areBuildingsLoading$(),
            this._deliveryPointsProvider.areDeliveryPointsLoading$(),
            this._profileProvider.isProfileLoading$(),
            this._contactsProvider.areContactsLoading$(),
            this._usageProvider.areUsagesLoading$(),
            this._metersProvider.areMetersLoading$(),
            this._sensorsProvider.getIsSensorStatePending$(),
            this._categoriesProvider.areCategoriesLoading$(),
            this._businessIndicatorsProvider.isBusinessIndicatorsStatePending$(),
            this._dashboardsProvider.areDashboardsLoading$(),
            this._tailoredWidgetsProvider.areWidgetsLoading$()
        ]).pipe(
            map(loadingMarkers => loadingMarkers.some(isLoadingMarker => isLoadingMarker)),
            debounce(isLoading => (isLoading ? of(null) : interval(500))) // wait a bit before switching to "not loading" state to avoid blinking
        );
    }
}
